import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
    const { login } = useAuth();
    const navigate  = useNavigate();
    const [email,    setEmail]    = useState('');
    const [password, setPassword] = useState('');
    const [error,    setError]    = useState('');
    const [loading,  setLoading]  = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setLoading(true);
        try {
            const user = await login(email, password);
            if (user.user_type === 'gardener') navigate('/gardener/dashboard');
            else if (user.user_type === 'buyer') navigate('/buyer/dashboard');
            else navigate('/admin/dashboard');
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed. Please try again.');
        } finally { setLoading(false); }
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h2 style={styles.title}>🌿 Welcome back</h2>
                <p style={styles.sub}>Sign in to your GardenHand account</p>
                {error && <div style={styles.error}>{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div style={styles.field}>
                        <label style={styles.label}>Email</label>
                        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} style={styles.input} placeholder="your@email.com" required />
                    </div>
                    <div style={styles.field}>
                        <label style={styles.label}>Password</label>
                        <input type="password" value={password} onChange={e=>setPassword(e.target.value)} style={styles.input} placeholder="Your password" required />
                    </div>
                    <button type="submit" style={styles.btn} disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
                <p style={styles.forgot}>
                    <Link to="/forgot-password" style={styles.link}>Forgot your password?</Link>
                </p>
                <p style={styles.footer}>Don't have an account? <Link to="/register" style={styles.link}>Sign up free</Link></p>
                {/* Development only. These buttons fill in real credentials —
                    including the admin account — so they must never render in
                    production. Create React App inlines NODE_ENV at build time,
                    so this whole block is stripped from the production bundle. */}
                {process.env.NODE_ENV === 'development' && (
                <div style={styles.testLogins}>
                    <p style={{fontSize:'0.75rem',color:'#888',marginBottom:'8px'}}>Quick test logins:</p>
                    <button style={styles.testBtn} onClick={()=>{setEmail('bruce.green@email.com');setPassword('Password123!');}}>Bruce (Gardener)</button>
                    <button style={styles.testBtn} onClick={()=>{setEmail('john.buyer@email.com');setPassword('Password123!');}}>John (Buyer)</button>
                    <button style={styles.testBtn} onClick={()=>{setEmail('admin@gardenmarket.com.au');setPassword('Password123!');}}>Admin</button>
                </div>
                )}
            </div>
        </div>
    );
}

const styles = {
    page:      { minHeight:'80vh', display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:'#f8fdf9', padding:'24px' },
    card:      { background:'white', borderRadius:'12px', padding:'40px', width:'100%', maxWidth:'420px', boxShadow:'0 4px 20px rgba(0,0,0,0.1)' },
    title:     { margin:'0 0 8px', color:'#2d6a4f', fontSize:'1.6rem', textAlign:'center' },
    sub:       { textAlign:'center', color:'#666', marginBottom:'24px' },
    error:     { backgroundColor:'#fee', border:'1px solid #fcc', borderRadius:'6px', padding:'10px 14px', color:'#c00', marginBottom:'16px', fontSize:'0.9rem' },
    field:     { marginBottom:'16px' },
    label:     { display:'block', marginBottom:'6px', fontWeight:'500', color:'#333', fontSize:'0.9rem' },
    input:     { width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'1rem', boxSizing:'border-box' },
    btn:       { width:'100%', padding:'12px', backgroundColor:'#2d6a4f', color:'white', border:'none', borderRadius:'6px', fontSize:'1rem', fontWeight:'bold', cursor:'pointer', marginTop:'8px' },
    forgot:    { textAlign:'center', marginTop:'14px', marginBottom:'4px', fontSize:'0.88rem' },
    footer:    { textAlign:'center', marginTop:'20px', color:'#666', fontSize:'0.9rem' },
    link:      { color:'#2d6a4f', fontWeight:'bold' },
    testLogins:{ marginTop:'24px', padding:'12px', background:'#f5f5f5', borderRadius:'6px', textAlign:'center' },
    testBtn:   { margin:'0 4px', padding:'4px 10px', fontSize:'0.75rem', backgroundColor:'#e8f5e9', border:'1px solid #a5d6a7', borderRadius:'4px', cursor:'pointer' },
};
